import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ApiPrefixInterceptor } from './interceptors/api-prefix.interceptor';
import { CustomAuthHttpInterceptor } from './interceptors/custom-auth-http.interceptor';
import { ConpulseModule } from '@conpulse-web/conpulse';

@NgModule({
  declarations: [],
  imports: [CommonModule, ConpulseModule, HttpClientModule, BrowserAnimationsModule, FormsModule, I18NextModule],
  entryComponents: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  static configureEnvironment(env): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [{ provide: 'AppEnvironment', useValue: env }],
    };
  }
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
